<script setup lang="ts">
import {onMounted, ref, watch} from "vue";
import {useApp} from "@/shared/app.ts";
import BlogList from "@/apps/pages/comp/BlogList.vue";
import BlogSidebar from "@/apps/pages/comp/BlogSidebar.vue";

const app = useApp()

const loader = ref<{ list?: boolean, sidebar?: boolean }>({})
const isLoading = ref<boolean>(true)

const handleBlogListLoaded = () => {
  loader.value.list = true
}

const handleBlogSidebarLoaded = () => {
  loader.value.sidebar = true
}

watch([loader, loader.value], async () => {
  if (loader.value.list && loader.value.sidebar) {
    await app.helpers.async.sleep(1000)
    isLoading.value = false
  }
})

onMounted(async () => {
  isLoading.value = true
})
</script>

<template>
  <div v-if="isLoading" id="preloader"></div>
  <section class="top-position1 pt-0 pb-5">
    <div class="page-title-section bg-img cover-background" data-overlay-dark="7">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h1>Our Blog</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="breadcrumb">
            <ul>
              <li>
                <router-link :to="{name:'home'}">Home</router-link>
              </li>
              <li>
                <router-link :to="{name:'blog'}">Our Blog</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="pt-0">
    <div class="container">
      <div class="row mt-3">
        <div class="col-lg-8 mt-n2-9 mb-2-9 mb-lg-0">
          <blog-list @loaded="handleBlogListLoaded"/>
        </div>
        <div class="col-lg-4">
          <blog-sidebar @loaded="handleBlogSidebarLoaded"/>
        </div>
      </div>
    </div>
  </section>
</template>